module.exports = __webpack_public_path__ + "img/photozone-3.71a2276b.jpg";